import React from "react";
import { CardTitle } from "components/cardTitle";
import "./MoveListCard.scss"
import { ListItemB } from "components/listItemB";
import { IMove, MovePaymentStatusEnum, MoveStatusEnum } from "core/model/move";
import { CardLayout } from "components/cardLayout";
import { navigate } from "@reach/router";
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'

const PAGE_SIZE = 5;
// const transportData = [
//     {type: 'Loading', summary: '3 Movers, 1 Truck', amount: '$522', hour: '3 HRS x $183 '},
//     {type: 'Unloading', summary: '3 Movers, 1 Truck', amount: '$378', hour: '3 HRS x $183 '},
//     {type: 'Travel', summary: '', amount: '1 X $189', hour: ' '},
//     {type: 'Fuel', summary: '', amount: '$25', hour: ''},
//     {type: 'Materials', summary: '', amount: '$105.70', hour: ''},   
// ]
export interface MoveListCardProps {
    title?: string;
    list?: IMove[] | null;
    paymentStatuses?: MovePaymentStatusEnum[];
    moveStatuses?: MoveStatusEnum[];
    onClick?(item: any): void;
    cancelAmount?: boolean;
    cancelTotalAmount?: boolean;
    iconName?: any;
    totalValue?: any;
    text?: any;
    data: any[];
}

export interface MoveListCardState {

}

class MoveListCard extends React.Component<MoveListCardProps, MoveListCardState> {

    constructor(props: MoveListCardProps) {
        super(props);
        this.state = { rating: 4 };
    }

    handleClick(item: any) {
        if (this.props.onClick) {
            this.props.onClick(item);
        }
    }

    onExpand() {
        navigate('/moves', {
            state: {
                title: this.props.title,
                paymentStatuses: this.props.paymentStatuses,
                moveStatuses: this.props.moveStatuses
            }
        })
    }

    onStarClick(nextValue: any, prevValue: any, name: any) {
        this.setState({ rating: nextValue });
    }

    getTotalCommissionAmount(list: IMove[]) {
        return list.map(item => +item.commissionAmount).reduce((a, b) => a + b, 0).toFixed(2);
    }

    render() {
        const { list, title } = this.props;
        return (
            <CardLayout
            // paginator={list ? {
            //     pageSize: list.length < PAGE_SIZE ? list.length: PAGE_SIZE,
            //     totalCount: list.length
            // } : null}
            // loading={!list}
            // onExpand={() => this.onExpand()}
            >
                <CardTitle title={title}
                // cancelTotalAmount={this.props.cancelTotalAmount} 
                // value={`$${this.getTotalCommissionAmount(list || [])}`} 
                />
                {
                    // (list || [])
                    //     .filter((item: any, index: any) => index < PAGE_SIZE)

                    this.props.data.map((item, index:number) => {
                          return <ListItemB
                                key={index}
                                item={item}
                                backgroundColor={index % 2 === 0 ? ' #F3F3F3' : '#FBFBFB'}
                                onClick={(item: any) => this.handleClick(item)}
                            // cancelAmount={this.props.cancelAmount}
                            />
                    })
                }
                {/* { list && list.length == 0 &&
                    <div className="nomove-text">
                      <p>No moves</p>
                        </div>
                } */}
                <div className="total-amount">
                    <p>{this.props.text}</p>
                    <p>{this.props.totalValue}</p>


                </div>
            </CardLayout>
        );
    }
}

export default MoveListCard;